import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import GradientButton from "../../components/GradientButton";
import EmailInput from "../../components/EmailInput";
import { useNavigate } from "react-router-dom";
import PasswordInput from "../../components/PasswordInput";
import ButtonContainer from "../../components/ButtonContainer";
import IconLink from "../../components/IconLink";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextLink from "../../components/TextLink";
import { useAuthService } from "../../api/authService";
import { toast } from "sonner";
import Loader from "../../components/Loader";

const Login = () => {
  const { login, isLoginLoading } = useAuthService();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      login(values.email, values.password)
        .then(() => {
          navigate("/runs");
        })
        .catch((error) => {
          toast.error("Incorrect username or password");
        });
    },
  });

  const navigate = useNavigate();

  return (
    <AuthFlowLayout
      headerText="Log in to your account"
      headerContent={
        <IconLink
          to="/"
          src="/Logo-light.svg"
          alt="Logo"
          className="mb-4 max-h-[4vh] min-h-12"
        />
      }
      isLoading={isLoginLoading}
      loader={<Loader />}
      // footer={
      //   <TextLink text="No account yet?" linkText="Sign up" to="/register" />
      // }
    >
      <form onSubmit={formik.handleSubmit}>
        <EmailInput
          {...formik.getFieldProps("email")}
          label="Email"
          error={formik.touched.email && formik.errors.email}
        />
        <PasswordInput
          {...formik.getFieldProps("password")}
          label="Password"
          error={formik.touched.password && formik.errors.password}
        />
        <div className="flex items-center mb-4 justify-between max-w-lg">
          <TextLink linkText="Forgot your password?" to="/forgot-password" />
        </div>
        <ButtonContainer
          firstButton={<GradientButton type="submit" text="Login" />}
        />
      </form>
    </AuthFlowLayout>
  );
};

export default Login;
